/* eslint-disable no-return-assign */
import React, { PureComponent } from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';
import { Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import TopbarMenuLink from './TopbarMenuLink';

const Ava = '/images/user/defaultAvatar.png';

class TopbarProfile extends PureComponent {
  static propTypes = {
    // user: UserProps.isRequired,
    // eslint-disable-next-line
    session: PropTypes.object.isRequired,
    // eslint-disable-next-line
    paths: PropTypes.object.isRequired,
  }


  constructor() {
    super();
    this.state = {
      collapse: false,
    };
  }

  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  logout = () => {
    // Clear main authentication token
    localStorage.removeItem('easydev');
    
    // Clear OIDC tokens
    const authSettings = localStorage.getItem('authSettings');
    if (authSettings) {
      try {
        const settings = JSON.parse(authSettings);
        const oidcKey = `oidc.user:${settings.auth_server}:${settings.client_id}`;
        localStorage.removeItem(oidcKey);
      } catch (e) {
        // Ignore parsing errors
      }
    }
    localStorage.removeItem('authSettings');
    
    // Clear any cached session data
    sessionStorage.clear();
    
    // Clear any other authentication-related localStorage items
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('oidc.') || key.includes('auth') || key.includes('session') || key.includes('token')) {
        localStorage.removeItem(key);
      }
    });
  }

  render() {
    const { session } = this.props;
    const { collapse } = this.state;

    // const h = new ViewHelpers();
    return (
      <div className="topbar__profile">
        <button className="topbar__avatar" type="button" onClick={this.toggle}>
          {session.advertiser.logoSquareUrl && (
            <img style={{ height: '36px', width: 'auto', margin: 'auto 0', borderRadius: '18px' }} src={session.advertiser.logoSquareUrl} alt="Brand Logo" />
          )}
          {!session.advertiser.logoSquareUrl && (
            <img className="topbar__avatar-img" src={Ava} alt="avatar" />
          )}
          <p className="topbar__avatar-name">{session.firstName} {session.lastName}</p>
          <DownIcon className="topbar__icon" />
        </button>
        {collapse && <button className="topbar__back" type="button" onClick={this.toggle} />}
        <Collapse isOpen={collapse} className="topbar__menu-wrap">
          <div className="topbar__menu">
            <TopbarMenuLink
              title="Account Settings"
              icon="cog"
              path="/settings"
              onClick={this.toggle}
            />
            <TopbarMenuLink
              title="Log Out"
              icon="exit"
              path="/logout"
              onClick={() => window.location.href = '/logout'}
            />
          </div>
        </Collapse>
      </div>
    );
  }
}

export default TopbarProfile;
